export default {
  baseURL: 'https://book.tripx.se',
  headers: {
    get: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
  },
};
